import React from 'react';

const useMap = ({ initialValues = [], key = 'id', getKey = (item) => item[key] } = {}) => {
  const [[map], setMap] = React.useState([new Map(initialValues)]);
  const castKey = React.useCallback((val) => (typeof val === 'object' ? getKey(val) : val), [getKey]);

  const stableActions = React.useMemo(() => {
    const add = (item, _key = getKey(item)) =>
      setMap(([prevMap]) => {
        prevMap.set(_key, item);
        return [prevMap];
      });

    const remove = (item) =>
      setMap(([prevMap]) => {
        prevMap.delete(castKey(item));
        return [prevMap];
      });

    const toggle = (item) =>
      setMap(([prevMap]) => {
        const itemKey = castKey(item);
        if (prevMap.has(itemKey)) {
          prevMap.delete(itemKey);
        } else {
          prevMap.set(itemKey, item);
        }

        return [prevMap];
      });

    const reset = () => setMap(new Map(initialValues));

    return { add, delete: remove, remove, toggle, reset };
  }, [castKey, getKey, initialValues]);

  const utils = {
    has: React.useCallback((item) => map.has(castKey(item)), [castKey, map]),
    get: React.useCallback((item) => map.has(castKey(item)), [castKey, map]),
    ...stableActions,
  };

  return [map, utils];
};

export default useMap;
